const unwrapValue = (val) => {
  if (val && typeof val === "object" && "value" in val) {
    return val.value;
  }
  return val;
};

export const normalizeScanDetails = (data, screenLabels, is4Life) => {
  console.log(data);

  return [
    {
      category: "Wellness",
      metrics: [
        {
          key: "wellness",
          label: screenLabels?.wellness_score?.label_value || "Wellness Score",
          value: unwrapValue(data.body?.wellness_score),
          avg: unwrapValue(""),
          unit: "/10",
          status: data.body?.wellness_level,
          comment: data.body?.wellness_comment || "",
        },
      ],
    },
    {
      category: "Body",
      metrics: [
        {
          key: "body_mass_index",
          label:
            screenLabels?.body_mass_index_comment?.label_value ||
            "Body Mass Index",
          value: unwrapValue(data.body?.body_mass_index),
          avg: unwrapValue(data.body?.body_mass_index_avg),
          normal: unwrapValue(data.body?.body_mass_index_normal),
          status: data.body?.body_mass_index_status,
        },
        {
          key: "physiological_strain_index_(psi)",
          label:
            screenLabels?.physiological_strain_index_comment?.label_value ||
            "Physiological Strain Index",
          value: unwrapValue(data.body?.physiological_strain_index),
          avg: unwrapValue(data.body?.physiological_strain_index_avg),
          normal: unwrapValue(data.body?.physiological_strain_index_normal),
          status: data.body?.physiological_strain_index_status,
        },
        {
          key: "waist_to_hip_ratio",
          label:
            screenLabels?.waist_to_hip_ratio_comment?.label_value ||
            "Waist To Hip Ratio",
          value: unwrapValue(data.body?.waist_to_hip_ratio),
          avg: unwrapValue(data.body?.waist_to_hip_ratio_avg),
          normal: unwrapValue(data.body?.waist_to_hip_ratio_normal),
          status: data.body?.waist_to_hip_ratio_status,
        },
        {
          key: "waist_to_height_ratio",
          label:
            screenLabels?.waist_to_height_ratio_comment?.label_value ||
            "Waist-To-Height Ratio",
          value: unwrapValue(data.body?.waist_to_height_ratio),
          avg: unwrapValue(data.body?.waist_to_height_ratio_avg),
          normal: unwrapValue(data.body?.waist_to_height_ratio_normal),
          status: data.body?.waist_to_height_ratio_status,
        },
        {
          key: "body_shape_index",
          label:
            screenLabels?.body_shape_index_comment?.label_value ||
            "Body Shape Index",
          value: unwrapValue(data.body?.body_shape_index),
          avg: unwrapValue(data.body?.body_shape_index_avg),
          normal: unwrapValue(data.body?.body_shape_index_normal),
          status: data.body?.body_shape_index_status,
        },
        {
          key: "fatigue_index",
          label:
            screenLabels?.fatigue_index_comment?.label_value || "Fatigue Index",
          value: unwrapValue(data.body?.fatigue_index),
          avg: unwrapValue(data.body?.fatigue_index_avg),
          normal: unwrapValue(data.body?.fatigue_index_normal),
          status: data.body?.fatigue_index_avg_status,
        },
        {
          key: "inflammation_index",
          label:
            screenLabels?.inflammation_index_comment?.label_value ||
            "Inflammation Index",
          value: unwrapValue(data.body?.inflammation_index),
          avg: unwrapValue(data.body?.inflammation_index_avg),
          normal: unwrapValue(data.body?.inflammation_index_normal),
          status: data.body?.inflammation_index_status,
        },
        {
          key: "metabolic_efficiency_ratio",
          label: is4Life
            ? screenLabels?.fitness_efficiency?.label_value ||
              "Fitness Efficiency"
            : screenLabels?.metabolic_efficiency_ratio_comment?.label_value ||
              "Metabolic Efficiency Ratio",
          value: unwrapValue(data.body?.metabolic_efficiency_ratio),
          avg: unwrapValue(data.body?.metabolic_efficiency_ratio_avg),
          normal: unwrapValue(data.body?.metabolic_efficiency_ratio_normal),
          status: data.body?.metabolic_efficiency_ratio_status,
        },
        {
          key: "metabolic_health_score",
          label:
            screenLabels?.metabolic_health_score_comment?.label_value ||
            "Metabolic Health Score",
          value: unwrapValue(data.body?.metabolic_health_score),
          avg: unwrapValue(data.body?.metabolic_health_score_avg),
          normal: unwrapValue(data.body?.metabolic_health_score_normal),
          status: data.body?.metabolic_health_score_status,
        },
      ],
    },
    {
      category: "Blood",
      metrics: [
        {
          key: "hemoglobin",
          label: screenLabels?.hemoglobin_comment?.label_value || "Hemoglobin",
          value: unwrapValue(data.blood?.hemoglobin),
          avg: unwrapValue(data.blood?.hemoglobin_avg),
          normal: unwrapValue(data.blood?.hemoglobin_normal),
          status: data.blood?.hemoglobin_status,
        },
        {
          key: "hba1c",
          label: is4Life
            ? screenLabels?.average_blood_sugar?.label_value ||
              "Average Blood Sugar"
            : screenLabels?.hemoglobin_a1c_comment?.label_value || "HbA1c",
          value: unwrapValue(data.blood?.hemoglobin_a1c),
          avg: unwrapValue(data.blood?.hemoglobin_a1c_avg),
          normal: unwrapValue(data.blood?.hemoglobin_a1c_normal),
          status: data.blood?.hemoglobin_a1c_status,
        },
        {
          key: "hemoglobin_score",
          label:
            screenLabels?.hemoglobin_score?.label_value || "Hemoglobin Score",
          value: unwrapValue(data.blood?.hemoglobin_score),
          avg: unwrapValue(data.blood?.hemoglobin_score_avg),
          normal: unwrapValue(data.blood?.hemoglobin_score_normal),
          status: data.blood?.hemoglobin_score_status,
        },
        {
          key: "average_blood_glucose",
          label: is4Life
            ? screenLabels?.blood_sugar_score?.label_value ||
              "Blood Sugar Score"
            : screenLabels?.average_blood_glucose?.label_value ||
              "Average Blood Glucose",
          value: unwrapValue(data.blood?.average_blood_glucose),
          avg: unwrapValue(data.blood?.average_blood_glucose_avg),
          normal: unwrapValue(data.blood?.average_blood_glucose_normal),
          status: data.blood?.average_blood_glucose_status,
        },
        {
          key: "anemia_index",
          label: is4Life
            ? screenLabels?.red_blood_cell_health?.label_value ||
              "Red Blood Cell Health"
            : screenLabels?.anemia_index?.label_value || "Anemia Index",
          value: unwrapValue(data.blood?.anemia_index),
          avg: unwrapValue(data.blood?.anemia_index_avg),
          normal: unwrapValue(data.blood?.anemia_index_normal),
          status: data.blood?.anemia_index_status,
        },
        {
          key: "glucose_management_indicator",
          label: is4Life
            ? screenLabels?.glucose_indicator?.label_value ||
              "Glucose Indicator"
            : screenLabels?.glucose_management_indicator?.label_value ||
              "Glucose Management Indicator",
          value: unwrapValue(data.blood?.glucose_management_indicator),
          avg: unwrapValue(data.blood?.glucose_management_indicator_avg),
          normal: unwrapValue(data.blood?.glucose_management_indicator_normal),
          status: data.blood?.glucose_management_indicator_status,
        },
      ],
    },
    {
      category: "Risks",
      metrics: [
        {
          key: "high_hba1c_risk",
          label: is4Life
            ? screenLabels?.a1C_risk?.label_value || "A1C Risk"
            : screenLabels?.high_hba1c_risk?.label_value || "High HbA1c Risk",
          value: unwrapValue(data.risks?.high_hba1c_risk),
          avg: unwrapValue(data.risks?.high_hba1c_risk_avg),
          normal: unwrapValue(data.risks?.high_hba1c_risk_normal),
          status: data.risks?.high_hba1c_risk_status,
        },
        {
          key: "high_blood_pressure_risk",
          label: is4Life
            ? screenLabels?.high_bP_risk?.label_value || "High BP Risk"
            : screenLabels?.high_blood_pressure_risk_comment?.label_value ||
              "High Blood Pressure Risk",
          value: unwrapValue(data.risks?.high_blood_pressure_risk),
          avg: unwrapValue(data.risks?.high_blood_pressure_risk_avg),
          normal: unwrapValue(data.risks?.high_blood_pressure_risk_normal),
          status: data.risks?.high_blood_pressure_risk_status,
        },
        {
          key: "ascvd_risk",
          label: is4Life
            ? screenLabels?.heart_risk_score?.label_value || "Heart Risk Score"
            : screenLabels?.ascvd_risk_comment?.label_value || "ASCVD Risk",
          value: unwrapValue(data.risks?.ascvd_risk),
          avg: unwrapValue(data.risks?.ascvd_risk_avg),
          normal: unwrapValue(data.risks?.ascvd_risk_normal),
          status: data.risks?.ascvd_risk_status,
        },
        {
          key: "high_fasting_glucose_risk",
          label: is4Life
            ? screenLabels?.blood_sugar_risk?.label_value || "Blood Sugar Risk"
            : screenLabels?.high_fasting_glucose_risk?.label_value ||
              "High Fasting Glucose Risk",
          value: unwrapValue(data.risks?.high_fasting_glucose_risk),
          avg: unwrapValue(data.risks?.high_fasting_glucose_risk_avg),
          normal: unwrapValue(data.risks?.high_fasting_glucose_risk_normal),
          status: data.risks?.high_fasting_glucose_risk_status,
        },
        {
          key: "high_cholesterol_risk",
          label: is4Life
            ? screenLabels?.cholesterol_health?.label_value ||
              "Cholesterol Health"
            : screenLabels?.cholesterol_risk?.label_value || "Cholesterol Risk",
          value: unwrapValue(data.risks?.high_total_cholesterol_risk),
          avg: unwrapValue(data.risks?.high_total_cholesterol_risk_avg),
          normal: unwrapValue(data.risks?.high_total_cholesterol_risk_normal),
          status: data.risks?.high_total_cholesterol_risk_status,
        },
        {
          key: "hypertension_risk_score",
          label:
            screenLabels?.hypertension_risk_score?.label_value ||
            "Hypertension Risk",
          value: unwrapValue(data.risks?.hypertension_risk_score),
          avg: unwrapValue(data.risks?.hypertension_risk_score_avg),
          normal: unwrapValue(data.risks?.hypertension_risk_score_normal),
          status: data.risks?.hypertension_risk_score_status,
        },
        {
          key: "low_hemoglobin_risk",
          label:
            screenLabels?.low_hemoglobin_risk_comment?.label_value ||
            "Low Hemoglobin Risk",
          value: unwrapValue(data.risks?.low_hemoglobin_risk),
          avg: unwrapValue(data.risks?.low_hemoglobin_risk_avg),
          normal: unwrapValue(data.risks?.low_hemoglobin_risk_normal),
          status: data.risks?.low_hemoglobin_risk_status,
        },
        {
          key: "tuberculosis_risk",
          label:
            screenLabels?.tuberculosis_risk_comment?.label_value ||
            "Tuberculosis Risk",
          value: unwrapValue(data.risks?.tuberculosis_risk),
          avg: unwrapValue(data.risks?.tuberculosis_risk_avg),
          normal: unwrapValue(data.risks?.tuberculosis_risk_normal),
          status: data.risks?.tuberculosis_risk_status,
        },
      ],
    },
    {
      category: "Stress",
      metrics: [
        {
          key: "stress_level",
          label:
            screenLabels?.stress_level_comment?.label_value || "Stress Level",
          value: unwrapValue(data.stress?.stress_level),
          avg: unwrapValue(data.stress?.stress_level_avg),
          normal: unwrapValue(data.stress?.stress_level_normal),
          status: data.stress?.stress_level_status,
        },
        {
          key: "stress_index",
          label:
            screenLabels?.stress_index_comment?.label_value || "Stress Index",
          value: unwrapValue(data.stress?.stress_index),
          avg: unwrapValue(data.stress?.stress_index_avg),
          normal: unwrapValue(data.stress?.stress_index_normal),
          status: data.stress?.stress_index_status,
        },
        {
          key: "normalized_stress_index",
          label: is4Life
            ? screenLabels?.stress_score?.label_value || "Stress Score"
            : screenLabels?.normalized_stress_index_comment?.label_value ||
              "Normalized Stress Index",
          value: unwrapValue(data.stress?.normalized_stress_index),
          avg: unwrapValue(data.stress?.normalized_stress_index_avg),
          normal: unwrapValue(data.stress?.normalized_stress_index_normal),
          status: data.stress?.normalized_stress_index_status,
        },
        {
          key: "mean_rri",
          label: is4Life
            ? screenLabels?.heartbeat_interval?.label_value ||
              "Heartbeat Interval"
            : screenLabels?.mean_rri_comment?.label_value || "Mean RRI",
          value: unwrapValue(data.stress?.mean_rri),
          avg: unwrapValue(data.stress?.mean_rri_avg),
          normal: unwrapValue(data.stress?.mean_rri_normal),
          status: data.stress?.mean_rri_status,
        },
        {
          key: "rmssd",
          label: is4Life
            ? screenLabels?.recovery_variable?.label_value ||
              "Recovery Variable"
            : screenLabels?.rmssd?.label_value || "Rmssd",
          value: unwrapValue(data.stress?.rmssd),
          avg: unwrapValue(data.stress?.rmssd_avg),
          normal: unwrapValue(data.stress?.rmssd_normal),
          status: data.stress?.rmssd_status,
        },
        {
          key: "recovery_ability_pns_zone",
          label:
            screenLabels?.recovery_ability?.label_value || "Recovery Ability",
          value: unwrapValue(data.stress?.recovery_ability_pns_zone),
          avg: unwrapValue(data.stress?.recovery_ability_pns_zone_avg),
          normal: unwrapValue(data.stress?.recovery_ability_pns_zone_normal),
          status: data.stress?.recovery_ability_pns_zone_status,
        },
        {
          key: "pns_index",
          label: is4Life
            ? screenLabels?.recovery_index?.label_value || "Recovery Index"
            : screenLabels?.pns_index?.label_value || "PNS Index",
          value: unwrapValue(data.stress?.pns_index),
          avg: unwrapValue(data.stress?.pns_index_avg),
          normal: unwrapValue(data.stress?.pns_index_normal),
          status: data.stress?.pns_index_status,
        },
        {
          key: "stress_response_sns_zone",
          label:
            screenLabels?.stress_response?.label_value || "Stress Response",
          value: unwrapValue(data.stress?.stress_response_sns_zone),
          avg: unwrapValue(data.stress?.stress_response_sns_zone_avg),
          normal: unwrapValue(data.stress?.stress_response_sns_zone_normal),
          status: data.stress?.stress_response_sns_zone_status,
        },
        {
          key: "sns_index",
          label: is4Life
            ? screenLabels?.stress_activation?.label_value ||
              "Stress Activation"
            : screenLabels?.sns_index?.label_value || "SNS Index",
          value: unwrapValue(data.stress?.sns_index),
          avg: unwrapValue(data.stress?.sns_index_avg),
          normal: unwrapValue(data.stress?.sns_index_normal),
          status: data.stress?.sns_index_status,
        },
        {
          key: "sd1",
          label: is4Life
            ? screenLabels?.recovery_signal?.label_value || "Recovery Signal"
            : screenLabels?.sd1_comment?.label_value || "SD 1",
          value: unwrapValue(data.stress?.sd1),
          avg: unwrapValue(data.stress?.sd1_avg),
          normal: unwrapValue(data.stress?.sd1_normal),
          status: data.stress?.sd1_status,
        },
        {
          key: "sd2",
          label: is4Life
            ? screenLabels?.stress_pattern?.label_value || "Stress Pattern"
            : screenLabels?.sd2_comment?.label_value || "SD 2",
          value: unwrapValue(data.stress?.sd2),
          avg: unwrapValue(data.stress?.sd2_avg),
          normal: unwrapValue(data.stress?.sd2_normal),
          status: data.stress?.sd2_status,
        },
        {
          key: "lf_hf",
          label: is4Life
            ? screenLabels?.stress_balance?.label_value || "Stress Balance"
            : screenLabels?.lf_hf_comment?.label_value || "LF/HF Ratio",
          value: unwrapValue(data.stress?.lf_hf),
          avg: unwrapValue(data.stress?.lf_hf_avg),
          normal: unwrapValue(data.stress?.lf_hf_normal),
          status: data.stress?.lf_hf_status,
        },
      ],
    },
    {
      category: "Heart Health",
      metrics: [
        {
          key: "blood_pressure",
          label:
            screenLabels?.blood_pressure_comment?.label_value ||
            "Blood Pressure",
          value: unwrapValue(data.heart_health?.blood_pressure),
          avg: unwrapValue(data.heart_health?.blood_pressure_avg),
          normal: unwrapValue(data.heart_health?.blood_pressure_normal),
          status: data.heart_health?.blood_pressure_status,
        },
        {
          key: "heart_rate",
          label: screenLabels?.heart_rate?.label_value || "Heart Rate",
          value: unwrapValue(data.heart_health?.heart_rate),
          avg: unwrapValue(data.heart_health?.heart_rate_avg),
          normal: unwrapValue(data.heart_health?.heart_rate_normal),
          status: data.heart_health?.heart_rate_normal,
        },
        {
          key: "breating_rate",
          label:
            screenLabels?.breating_rate_comment?.label_value ||
            "Breathing Rate",
          value: unwrapValue(data.heart_health?.breathing_rate),
          avg: unwrapValue(data.heart_health?.breathing_rate_avg),
          normal: unwrapValue(data.heart_health?.breathing_rate_normal),
          status: data.heart_health?.breathing_rate_normal,
        },
        {
          key: "oxygen_saturation",
          label:
            screenLabels?.oxygen_saturation_comment?.label_value ||
            "Oxygen Saturation",
          value: unwrapValue(data.heart_health?.oxygen_saturation),
          avg: unwrapValue(data.heart_health?.oxygen_saturation_avg),
          normal: unwrapValue(data.heart_health?.oxygen_saturation_normal),
          status: data.heart_health?.oxygen_saturation_status,
        },
        {
          key: "hrv_sdnn",
          label: is4Life
            ? screenLabels?.heart_rate_variability?.label_value ||
              "Heart Rate Variability"
            : screenLabels?.hrv_sdnn_comment?.label_value || "HRV SDNN",
          value: unwrapValue(data.heart_health?.hrv_sdnn),
          avg: unwrapValue(data.heart_health?.hrv_sdnn_avg),
          normal: unwrapValue(data.heart_health?.hrv_sdnn_normal),
          status: data.heart_health?.hrv_sdnn_status,
        },
        {
          key: "pulse_rate_quotient",
          label: is4Life
            ? screenLabels?.heart_rate_synch?.label_value || "Heart Rate Synch"
            : screenLabels?.pulse_rate_quotient_comment?.label_value ||
              "Pulse Rate Quotient (PRQ)",
          value: unwrapValue(data.heart_health?.pulse_rate_quotient),
          avg: unwrapValue(data.heart_health?.pulse_rate_quotient_avg),
          normal: unwrapValue(data.heart_health?.pulse_rate_quotient_normal),
          status: data.heart_health?.pulse_rate_quotient_status,
        },
        {
          key: "pulse_rate",
          label: screenLabels?.pulse_rate_comment?.label_value || "Pulse Rate",
          value: unwrapValue(data.heart_health?.pulse_rate),
          avg: unwrapValue(data.heart_health?.pulse_rate_avg),
          normal: unwrapValue(data.heart_health?.pulse_rate_normal),
          status: data.heart_health?.pulse_rate_status,
        },
        {
          key: "heart_age",
          label: screenLabels?.heart_age_comment?.label_value || "Heart Age",
          value: unwrapValue(data.heart_health?.heart_age),
          avg: unwrapValue(data.heart_health?.heart_age_avg),
          normal: unwrapValue(data.heart_health?.heart_age_normal),
          status: data.heart_health?.heart_age_status,
          cronologicalAge: data.heart_health?.chronological_age
            ? `${data.heart_health?.chronological_age} years`
            : "-",
        },
        {
          key: "vo2_max",
          label: is4Life
            ? screenLabels?.cardio_fitness_level?.label_value ||
              "Cardio Fitness Level"
            : screenLabels?.vo2_max_comment?.label_value || "VO2Max",
          value: unwrapValue(data.heart_health?.vo2_max),
          avg: unwrapValue(data.heart_health?.vo2_max_avg),
          normal: unwrapValue(data.heart_health?.vo2_max_normal),
          status: data.heart_health?.vo2_max_status,
        },
        {
          key: "mean_arterial_pressure",
          label:
            screenLabels?.mean_arterial_pressure_comment?.label_value ||
            "Mean Arterial Pressure",
          value: unwrapValue(data.heart_health?.mean_arterial_pressure),
          avg: unwrapValue(data.heart_health?.mean_arterial_pressure_avg),
          normal: unwrapValue(data.heart_health?.mean_arterial_pressure_normal),
        },
        {
          key: "bp_systolic",
          label: is4Life
            ? screenLabels?.upper_blood_pressure?.label_value ||
              "Upper Blood Pressure"
            : screenLabels?.bp_systolic?.label_value || "Bp Systolic",
          value: unwrapValue(data.heart_health?.bp_systolic),
          avg: unwrapValue(data.heart_health?.bp_systolic_avg),
          normal: unwrapValue(data.heart_health?.bp_systolic_normal),
        },
        {
          key: "bp_diastolic",
          label: is4Life
            ? screenLabels?.lower_blood_pressure?.label_value ||
              "Lower Blood Pressure"
            : screenLabels?.bp_diastolic?.label_value || "Bp Diastolic",
          value: unwrapValue(data.heart_health?.bp_diastolic),
          avg: unwrapValue(data.heart_health?.bp_diastolic_avg),
          normal: unwrapValue(data.heart_health?.bp_diastolic_normal),
        },
        {
          key: "cardiac_workload",
          label: is4Life
            ? screenLabels?.heart_effort_score?.label_value ||
              "Heart Effort Score"
            : screenLabels?.cardiac_workload_comment?.label_value ||
              "Cardiac Workload",
          value: unwrapValue(data.heart_health?.cardiac_workload),
          avg: unwrapValue(data.heart_health?.cardiac_workload_avg),
          normal: unwrapValue(data.heart_health?.cardiac_workload_normal),
        },
        {
          key: "pulse_pressure",
          label:
            screenLabels?.pulse_pressure_comment?.label_value ||
            "Pulse Pressure",
          value: unwrapValue(data.heart_health?.pulse_pressure),
          avg: unwrapValue(data.heart_health?.pulse_pressure_avg),
          normal: unwrapValue(data.heart_health?.pulse_pressure_normal),
        },
      ],
    },
  ];
};

// Some factor keys from the scan API should display under a different label
// key than their raw key (e.g. "sd2" should read "Stress Pattern").
const BIOMARKER_LABEL_ALIAS = {
  sd2: "stress_pattern",
  bp_systolic: "upper_blood_pressure",
  bp_diastolic: "lower_blood_pressure",
  ascvd_risk: "heart_risk_score",
  waist_to_height_ratio_comment: "waist_to_height_ratio_comment",
  glucose: "blood_sugar_score",
};

export const formatBiomarkerName = (key, screenLabels) => {
  if (!key) return "";

  const formattedKey = key.toLowerCase().replace(/\s+/g, "_");
  const labelKey = BIOMARKER_LABEL_ALIAS[formattedKey] || formattedKey;

  if (screenLabels?.[labelKey]?.label_value) {
    return screenLabels[labelKey].label_value;
  }

  return labelKey.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};
